import React from "react";
import { bool, node, string } from "prop-types";
import Block from "../Block";
import { classes } from "../utils/classes";

const Header = ({ children }) => {
	return <>{children}</>;
};

Header.propTypes = {
	children: node.isRequired,
};

const Body = ({ ...props }) => {
	return (
		<main>
			<Block role="main" {...props} />
		</main>
	);
};

Body.propTypes = {
	...Block.propTypes,
};

const Footer = ({ children }) => {
	return <>{children}</>;
};

Footer.propTypes = {
	children: node.isRequired,
};

const Layout = ({ bgColor = "transparent", children, isWrapper = false, className = "" }) => (
	<>
		<style>{`body{background-color: ${bgColor}}`}</style>
		{!isWrapper && !className ? (
			children
		) : (
			<div className={classes(isWrapper && "layout-wrapper", className)}>{children}</div>
		)}
	</>
);

Layout.propTypes = {
	children: node.isRequired,
	isWrapper: bool,
	bgColor: string,
	className: string,
};

Layout.Header = Header;
Layout.Body = Body;
Layout.Footer = Footer;

export default Layout;
